import React from 'react';
import { useUserDisplay } from '../../hooks/useUserDisplay';
import './UserGreeting.scss';

interface UserGreetingProps {
  className?: string;
  'aria-label'?: string;
}

const UserGreeting: React.FC<UserGreetingProps> = ({
  className = '',
  'aria-label': ariaLabel = 'User greeting'
}) => {
  const { displayName, isAuthenticated } = useUserDisplay();

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div
      className={`user-greeting ${className}`.trim()}
      role="banner"
      aria-label={ariaLabel}
    >
      <h1 className="user-greeting__text">
        Hello, {displayName}.
      </h1>
    </div>
  );
};

export default UserGreeting;